import React from 'react';
import { createRoot } from 'react-dom/client';
// Bootstrap 5 CSS is now loaded via the Rails asset pipeline (_bootstrap-custom.scss)
import SessionTimer from '../shared/session_timer';

// This was previous flagged by Datadog with a "Check origin of the event" warning. This is a false positive.
// The event listener is listening for the DOMContentLoaded event, which is a browser event that cannot be triggered through XSS.
// It is important to check the 'message' event, but others don't even have an event origin property.
document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('session-timer');
  const data = JSON.parse(node.getAttribute('data'));
  const root = createRoot(node);
  root.render(<SessionTimer {...data} />);
});
